import { render } from "./_trash.vue?vue&type=template&id=79fc6a66&lang=pug"
import script from "./_trash.vue?vue&type=script&lang=js"
export * from "./_trash.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__